import { NumberInput, TextInput, Select, ModalWindow, Root, MultilineInput, HashRef, Div, Checkbox, Snack, Span, RefString, DestroyingPatternContentSwitcher, HandlersCollection } from "@tblabs/truffle";
import moment from "moment";
import "moment/locale/pl";
import { DateTimeProvider } from "./Services/DateTimeProvider";
import { DateTimeSlider } from "./Components/Utils/DateTimeSlider";
import { Router } from "./Services/Router";
import { OrderGeneratorPage } from "./Pages/OrderGeneratorPage";
import { AuthApi } from "./Services/Auth/AuthApi";
import { UserLocalStorage } from "./Services/Auth/UserLocalStorage";
import { AuthService } from "./Services/Auth/AuthService";
import { MessageBus } from "./Services/MessageBus/MessageBus";
import { OnlineRepo } from "./Services/Storage/OnlineRepo";
import { RawOrder } from "./Models/RawOrder";
import { OrdersManager } from "./Services/OrdersManager";
import { OrderConverter } from "./Services/Converters/Order/OrderConverter";
import { AgentsProvider } from "./Services/AgentsProvider";
import { StepFactory } from "./Services/StepFactory";
import { OrdersViewPage } from "./Pages/Admin/OrdersView/OrdersViewPage";
import { CustomerOrderViewPage } from "./Pages/Customer/CustomerOrderViewPage";
import { AdminOrderViewPage } from "./Pages/Admin/OrderView/AdminOrderViewPage";
import { TicketToOrderConverter } from "./Services/TicketToOrderConverter";
import { Ticket } from "./Models/Ticket";
import { AdminOrderRawEditPage } from "./Pages/Admin/OrderEdit/AdminOrderRawEditPage";
import { AdminOrderEditPage } from "./Pages/Admin/OrderEdit/AdminOrderEditPage";
import { AdminLoginPage, AgentLoginPage } from "./Services/Auth/AdminLoginPage";
import { EmailSender } from "./Services/Notifier/EmailSender";
import { Notifier } from "./Services/Notifier/Notifier";
import { RawSpecteamShopContent } from "./Models/ProductsCatalog/RawSpecteamShopContent";
import { SpecteamShopContentProvider } from "./Services/SpecteamShopContentProvider";
import { AgentOrdersViewPage } from "./Pages/Agent/AgentOrdersViewPage";
import { FatalError } from "./Components/FatalError";
import { Box } from "./Components/Utils/Box";
import { EnvDetector } from "./Services/EnvDetector";
import { TopPanel } from "./Components/TopPanel";
import { InfoFrame } from "./Components/Utils/InfoFrame";
import { BitcoinPriceProvider } from "./Steps/Payment/Services/BitcoinPriceProvider";
import { Env } from "./Models/Env";
import { ExpansesRepo } from "./Services/ExpansesRepo";
import { RawExpanse } from "./Models/RawExpanse";
import { ExpensesPage } from "./Pages/Admin/ExpensesPage";
import { AgentsPage, Magazine, MagazinePage } from "./Pages/AgentsPage";
import { Center } from "./Components/Utils/Center";
import { DateSlider } from "./Components/Utils/DateSlider";


moment?.locale('pl')

NumberInput.DefaultCssClasses = "uk-input uk-form-width-small";
TextInput.DefaultCssClasses = "uk-input";
// Button.DefaultCssClasses = "uk-button uk-button-default";
Select.DefaultCssClasses = "uk-select";
ModalWindow.DefaultCssClasses = "tf-modal-window";
ModalWindow.Hook = Root.Hook;
MultilineInput.DefaultCssClasses = "uk-textarea";

// HandlersCollection.THROW_ON_MANY_HANDLERS_WARNING = true;


// export class QuickOrderUpdatePage extends Div
// {
//     constructor(private _manager: OrdersManager, private _router: Router, private _auth: AuthService)
//     {
//         super();

//         this.Append(
//             new TextInput(new RefString("")).Placeholder("Szukaj...").WidthAuto(),
//         )
//     }
// }

(async () =>
{
    DateTimeProvider.UseFake(moment("2025-02-05 12:00:00").toDate());
    DateTimeProvider.UseFakeSwitch.Storable("app-rtc-fake")
    DateTimeProvider._now.Storable("app-rtc").OnChange(v => pagesSwitcher.Refresh())

    const root = new Root("body")

    const _env = new EnvDetector();

    const _authApi = new AuthApi("https://auth.specteam.pl/v3");
    const _userStorage = new UserLocalStorage();
    const _auth = new AuthService(_authApi, _userStorage);
    _auth.TryLoginFromLocalStorage();

    const _messageBus = new MessageBus("https://storage.specteam.pl/v4", {
        Id: _auth.UserInfo?.User?.Id || "Anonymous",
        AuthToken: _auth.UserInfo?.Permissions?.OrdersRepoAccessToken || ""
    });

    const _ordersRepo = new OnlineRepo<RawOrder>(_messageBus, _env, "Orders");
    const _shopRepo = new OnlineRepo<RawSpecteamShopContent>(_messageBus, _env, "Shop");

    const pingResult = await _ordersRepo.Ping();
    if (!pingResult)
    {
        new Snack(`Connection error`, `Orders Server is not responding`, { autoCloseTimeout: 0 });
    }

    const _agents = new AgentsProvider(_auth);
    const _stepFactory = new StepFactory(_agents);
    const _converter = new OrderConverter(_stepFactory);
    const _emailSender = new EmailSender();
    const _notifier = new Notifier(_emailSender, _env);
    const _bitcoinPriceProvider = new BitcoinPriceProvider();

    const hash = new HashRef();
    const _router = new Router(hash);

    const _ticketsRepo = new OnlineRepo<Ticket>(_messageBus, _env, "Tickets");
    const _ticketConverter = new TicketToOrderConverter(_stepFactory);

    const _manager = new OrdersManager(_ordersRepo, _ticketsRepo, _ticketConverter, _converter, _auth, _notifier, _bitcoinPriceProvider);

    const _shop = new SpecteamShopContentProvider(_shopRepo);

    const pagesSwitcher = new DestroyingPatternContentSwitcher(hash)//.Margin(16)
        .AddContent("admin/login", () => new AdminLoginPage(_auth))
        .AddContent("agent/login", () => new AgentLoginPage(_auth))
        .AddContent("order/:orderId", ({ orderId }) => new CustomerOrderViewPage(_manager, _messageBus, orderId))
        .AddContent("agent/:agentId/tasks", ({ agentId }) => new AgentOrdersViewPage(_manager, _router, _auth, _agents, agentId))


    if (_auth.IsAuthorized)
    {
        const _expansesOnlineRepo = new OnlineRepo<RawExpanse[]>(_messageBus, _env, "Expanses");
        const _expansesRepo = new ExpansesRepo(_expansesOnlineRepo);

        const _magazine = new Magazine();

        pagesSwitcher
            // .AddContent("admin/quick-update", () => new QuickOrderUpdatePage(_manager, _router, _auth))
            .AddContent("magazine", () => new MagazinePage(_router, _auth, _magazine))
            .AddContent("admin/agents", () => new AgentsPage(_router, _auth, _agents))
            .AddContent("admin/orders", () => new OrdersViewPage(_manager, _router, _auth, _agents))
            .AddContent("admin/expanses", () => new ExpensesPage(_router, _auth, _agents, _expansesRepo))
            .AddContent("order-creation/:id", ({id}) => new OrderGeneratorPage(_manager, _router, _stepFactory, _agents, _shop, id))
            .AddContent("order-creation", () => new OrderGeneratorPage(_manager, _router, _stepFactory, _agents, _shop))
            .AddContent("admin/order/:orderId/view", ({ orderId }) => new AdminOrderViewPage(_manager, _messageBus, _router, _auth, _agents, orderId))
            .AddContent("admin/order/:orderId/raw", ({ orderId }) => new AdminOrderRawEditPage(_manager, _router, orderId))
            .AddContent("admin/order/:orderId/edit", ({ orderId }) => new AdminOrderEditPage(_manager, _router, _stepFactory, _shop, orderId))
            .AddContent("env/get", () => new Span("Current environment: " + _env.Env))
            .AddContent("clock/get", () => new Span("Current clock: " + DateTimeProvider.Now))
            .AddContent("clock/set/:date", ({ date }) =>
            {
                DateTimeProvider.UseFake(moment(date).toDate());
                return new Span("Clock set to " + date);
            })
            .AddContent("app/db/drop", () =>
            {
                _manager.Drop().then(() => root.Append(new Span("Dropped")))

                return new Span("Dropping...");
            })
    }


    pagesSwitcher.AddDefaultContent(() => new FatalError("Nic tu nie ma lub nie jesteś zalogowany"))

    pagesSwitcher.Refresh()

    // const showTools = new RefBool(true).Storable("show-tools");
    root.Class("main").Append(
        (_auth.IsAuthorized && _env.Env === Env.Prod && window.location.origin.includes("localhost")) &&
        new Center(
            new InfoFrame("⚠️ Produkcyjne dane na środowisku testowym", "Uwaga! Jesteś w środowisku testowym, ale załadowane są dane z produkcji. Wszystkie zmiany będą widoczne dla klientów."),
            new Checkbox(DateTimeProvider.UseFakeSwitch, "Use fake clock").MarginRight(16).DisplayInlineBlock(),
            new DateSlider(DateTimeProvider._now).DisplayInlineBlock(),
        ),

        (_auth.IsAuthorized && _env.Env === Env.Stage) &&
        new Box(
            new Span("@ " + _env.Env).FontSize(22).MarginRight(32),
            new Checkbox(DateTimeProvider.UseFakeSwitch, "Use fake clock").MarginRight(16).DisplayInlineBlock(),
            new DateSlider(DateTimeProvider._now).DisplayInlineBlock().Background("#222").Color("#eee"),
        ).Background("#111").Color("#eee").Padding(8).WidthPercent(100),
      
        _auth.IsAuthorized && new TopPanel(_router, _auth),
        new Div("main__container").Append(
            pagesSwitcher,
        ),
    )

    // document.addEventListener("keydown", (event) =>
    // {
    //     if (event.code === "Space")
    //     {
    //         showTools.Toggle();
    //     }
    // });

})()
